import { AppBundle } from 'api/optimalprint-sdk.d';
import { Popup } from 'components/Common/op-ui-wrappers/OpPopup/OpPopup';

export type OpRoute = AppBundle.Api.Response.App.V1.RoutingListV1Response.Route & {
  withLocalePrefix?: boolean;
};

export interface AppState {
  locale: string;
  categories: Category[];
  isLoggedIn: boolean;
  initialURL: string;
  initialData: unknown;
  env: string;
  currentPageParams: CurrentPageParams;
  opRoutes: OpRoute[];
  isBackdropVisible: boolean;
  isWaitingForNetwork: boolean;
  activePopup?: string;
  customerDeviceType: CustomerDeviceType;
  customerDeviceVerticallyOriented: boolean;
  customerDeviceScreenSize: CustomerDeviceScreenSize;
  configuration: ConfigurationObject;
  flows: ActiveFlows;
  trustpilot?: TrustpilotData;
  addingOpPlusToBasket?: boolean;
  popups: Popup[];
  addingProductToBasket: boolean;
}

interface ActiveFlows {
  [flow: string]: number;
}

export enum AvailableFlows {
  postAddToCart = 'postAddToCart',
}

export enum AvailablePopups {
  continueShopingPopup = 'continueShopingPopup',
  frameUpsellPopup = 'frameUpsellPopup',
  filterMobilePopup = 'filterMobilePopup',
  selectCategoryPopup = 'selectCategoryPopup',
  productDetailsPopup = 'productDetailsPopup',
  studioProductSelectionPopup = 'studioProductSelectionPopup',
  attributeSelectionMobilePopup = 'attributeSelectionMobilePopup',
  sizeGuidePopup = 'sizeGuidePopup',
}

export enum CustomerDeviceType {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
}

export enum CustomerDeviceScreenSize {
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
  XXL = 'XXL',
}

export interface Category extends AppBundle.Api.Response.Category.V2.CategoryListV2Response.ICategory {
  isSearchBasedCategory: boolean;
}

export interface ConfigurationObject {
  [key: string]: any;
}

export interface ReactAppConfiguration {
  useReactProductPagesForCategories: number[];
}

export interface CurrentPageParams {
  categoryId?: number;
  categoryName?: string;
  pageNr?: number;
  sortBy?: string;
  designId?: string;
  filter?: string;
  landingPageName?: string;
  productName?: string;
  productUid?: string;
}

export interface TrustpilotData {
  humanScore: number;
  score: number;
  stars: number;
  url: string;
  reviewsCount: number;
  domainRatingId: number;
  domainName: string;
  domainNameBusinessUnitId: string;
  createdAt: Date;
  updatedAt: Date;
}
